<template>
  <div class="cool-login-v2_container"
    v-if="show" v-fixed
    @click.self="maskHandle">
    <transition name="slide-fade">
      <div class="login-form-wrap">
        <h3 class="login-title">{{firstTitle}}</h3>
        <h4 class="login-sub-title"><img class="sub-title-icon" src="https://coolcdn.igetcool.com/p/2020/7/d5878cf1bf635bafe1ca0ec1f1839d2a.png?_54x54.png" alt="sub-title-icon"><span class="sut-txt">{{subTitle}}</span></h4>
        <span class="igetcool login-icon_tag cool-m-back"
          v-if="showCodeBlock"
          @click="backLastStep"></span>
        <span class="igetcool login-icon_tag cool-m-clear"
          @click="closeHandle"></span>
        <!-- 输入框部分 -->
        <div class="form-ipt_wrap">
          <template
            v-if="!showCodeBlock">
            <div class="ipt-item_wrap first-ipt-item">
              <div class="contry-code" @click="() => this.select.show = true">
                <span>+{{select.value}}</span>
                <span class="igetcool cool-m-arrow_down"></span>
              </div>
              <input class="phone-code-ipt" type="tel" pattern="[0-9]*" ref="mobileIpt"
                placeholder="请输入手机号"
                v-model="phone"
                :maxlength="maxPhonelength"
                @blur="inputDown"/>
              <span class="igetcool cool-guanbi1 clear-tag"
                v-if="this.phone != ''"
                @click="() => this.phone = ''"></span>
            </div>
            <button class="send-code-btn"
              :class="{'disabled-btn': validatePhone}"
              @click="sendCodeHandle">发送验证码</button>
          </template>
          <!-- 验证码部分 -->
          <template
            v-else>
            <div class="code-block_wrap">
              <input class="code-block_ipt" type="tel" maxlength="4" ref="codeIpt"
                v-model="code"
                @input="codeInputVal"
                @blur="inputDown"
                >
              <div class="square-wrap">
                <span class="square-item"
                  v-for="(item,index) in codeArr"
                  :key="index"
                  @click="activeInput($event,index)">
                  <span class="val" v-if="item.val!=''">{{item.val}}</span>
                </span>
              </div>
              <div class="bottom-act-wrap">
                <span class="act-btn right"
                  :class="{disactive: ifStart}"
                  @click="sendCodeHandle">{{ifStart ? `重新发送（${nowTime}s）` : '获取验证码'}}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>
    <!--号码选择器 -->
    <cool-country-select
      :select="select"/>
  </div>
</template>

<script>
import { fixed } from '@/utils/directives';
import CoolCountrySelect from '../CountrySelect';
import { validateMobile } from '@/utils/validate.js';
import {
  getCodeRequest,
  loginRegisterRequest
} from './serve';
import qs from 'qs';
import { RSAEncryptInstance } from './utils';

export default {
  name: 'CoolMLoginV2',
  props: {
    title: {
      type: String,
      default: '请输入手机号领取'
    },
    secondTitle: {
      type: String,
      default: '请输入验证码'
    },
    subTitle: {
      type: String,
      default: '20元好友推荐专属券'
    },
    show: Boolean,
    maskEvent: {
      type: Boolean,
      default: true
    },
    stringify: Boolean
  },
  data() {
    return {
      showCodeBlock: false,
      select: {
        show: false,
        value: 86
      },
      codeArr: [{ val: '' }, { val: '' }, { val: '' }, { val: '' }],
      code: '',
      phone: '',
      ifStart: false,
      fullTime: 60,
      nowTime: 60,
      timer: null,
      regLock: false,
      sendCodeLock: false
    };
  },
  watch: {
    show(boo) {
      !boo && this.initData(true);
    }
  },
  computed: {
    firstTitle() {
      return this.showCodeBlock ? this.secondTitle : this.title;
    },
    validatePhone() {
      return this.phone.length < (this.select.value == '86' ? 11 : 1);
    },
    tagName() {
      const showCodeBlock = this.showCodeBlock;
      return `cool-m-${showCodeBlock ? 'back' : 'clear'}`;
    },
    maxPhonelength() {
      return this.select.value !== 86 ? 1000 : 11;
    }
  },
  directives: {
    fixed
  },
  methods: {
    maskHandle() {
      this.maskEvent && this.closeHandle();
    },
    closeHandle() {
      if (this.regLock) { return false }
      this.$emit('cancel');
    },
    backLastStep() {
      this.initData();
    },
    codeInputVal(e) {
      this.code = this.code.replace(/[^0-9]/gi, '');
      this.codeArr.map(ele => {
        ele.val = '';
        return ele;
      });
      const CODE_LENGTH = 4;
      this.code.length > CODE_LENGTH && (this.code = this.code.slice(0, CODE_LENGTH));
      const codeArr = this.code.split('');
      for (let i = 0, len = codeArr.length; i < len; i++) {
        this.codeArr[i].val = codeArr[i];
      }
      (this.code.length === CODE_LENGTH) && this._registerAjax();
    },
    activeInput($e, index) {
      this.$refs.codeIpt.focus();
    },
    sendCodeHandle() {
      if (this.validatePhone || this.sendCodeLock) { return }
      this._lockRequestCode();
      this.code = '';
      this.codeArr.map(item => {
        item.val = '';
        return item;
      });
      let phoneStatus = validateMobile(this.phone, this.select.value);
      if (!phoneStatus) {
        this.$coolToast({
          text: '手机号码格式不正确',
          time: 3000
        });
        this._lockRequestCode();
        return;
      }
      if (this.ifStart) {
        this._unLockRequestCode();
        return;
      }
      this.sendCodeRequest();
    },
    _handleSendCode(res) {
      const errorMsgObj = {
        400011: '手机号已注册'
      };
      const error = errorMsgObj[res.code] || res.msg || '网络错误';
      if (res.code !== 10000) {
        this.$coolToast({
          text: error,
          time: 3000
        });
      }
    },
    _handleTimer() {
      clearTimeout(this.timer);
      this.nowTime = 60;
      this.ifStart = true;
      this.timer = setInterval(() => {
        this.nowTime = this.nowTime - 1;
        if (this.nowTime === 0) {
          this.ifStart = false;
          this.nowTime = this.fullTime;
          clearTimeout(this.timer);
        }
      }, 1000);
    },
    // 注册请求
    async _registerAjax() {
      if (this.regLock) { return }
      this._lockRequestCode(true);
      let p = this._getParams();
      let requestOptions = {
        ...p
      };
      if (typeof this.beforeLogin === 'function') {
        let result = this.beforeLogin(requestOptions);
        result && (requestOptions = result);
        this.beforeLogin = null;
      }
      try {
        let { params = qs.stringify(p), api, headers } = requestOptions;
        if (this.stringify) {
          params = qs.stringify(params);
        }
        const res = await loginRegisterRequest(params, api, headers);
        if (res.code === 10000) {
          this.loginSuccess(res.data);
        } else {
          this.$emit('error', res);
        }
      } catch (error) {

      }
      finally {
        this._unLockRequestCode(true);
      }
    },
    loginSuccess(data) {
      this.$emit('login', data);
    },
    _getParams() {
      this.$refs.codeIpt.blur();
      this.code = this.codeArr.reduce((pre, next) => pre + next.val, '');
      let params = {
        phone: RSAEncryptInstance(this.phone),
        countryCode: this.select.value || 86,
        smsCode: RSAEncryptInstance(this.code)
      };
      return params;
    },
    inputDown() {
      window.scrollTo(0, 0);
    },
    codeBlur() {
      window.scroll(0, 0);
    },
    async sendCodeRequest() {
      const query = {
        phone: RSAEncryptInstance(this.phone),
        countrycode: RSAEncryptInstance(this.select.value + '')
      };
      try {
        const res = await getCodeRequest(query);
        if (res.code === 10000) {
          this.ifStart = true;
          this._handleTimer();
          this.showCodeBlock = true;
        }
        this._handleSendCode(res);
      } catch (error) {
        this.$emit('error', error);
      }
      finally {
        this._unLockRequestCode();
      }
    },
    initData(all) {
      this.showCodeBlock = false;
      this.ifStart = false;
      all && (this.phone = '');
      this.codeArr.map(item => {
        item.val = '';
        return item;
      });
    },
    _lockRequestCode(reg) {
      if (reg) {
        this.regLock = true;
        return;
      }
      this.sendCodeLock = true;
    },
    _unLockRequestCode(reg) {
      if (reg) {
        this.regLock = false;
        return;
      }
      this.sendCodeLock = false;
    }
  },
  components: {
    CoolCountrySelect
  }
};
</script>

<style lang="stylus" scoped>
.cool-login-v2_container
  z-index 999
  position fixed
  top 0
  bottom 0
  left 0
  width 100%
  background-color rgba(0, 0, 0, .6)
  .icon-wrap
    position relative
    display flex
    padding 0 .15rem
    .title
      position absolute
      left 0
      right 0
      text-align center
      line-height .33rem
      font-size .18rem
      font-weight 700
      color #41414D
      pointer-events none

    &.phone-wrap
      justify-content flex-end



    .cool-fanhui
      color #989b9a


  .login-form-wrap
    position absolute
    bottom 0
    left 0
    right 0
    padding .18rem 0 .3rem
    font-size 0.16rem
    background-color #fff
    border-top-left-radius .16rem
    border-top-right-radius .16rem
  .login-icon_tag
    position absolute
    top .2rem
    right .2rem
    font-size 0.3rem
    font-weight bold
    color #a0a7b6
    &.cool-m-back
      left .2rem
  .login-title
    line-height .24rem
    font-size .2rem
    font-weight normal
    text-align center
    margin-bottom .1rem
  .login-sub-title
    display flex
    justify-content center
    align-items center
    line-height .2rem
    color #FF5E2E
    font-size .14rem
    font-weight normal
    .sub-title-icon
      display block
      width .18rem
      height .18rem
      margin-right .02rem
  .form-ipt_wrap
    width 2.91rem
    margin 0 auto
  .ipt-item_wrap
    display flex
    height 0.5rem
    border-bottom .01rem solid #d7d6d6

    &.first-ipt-item
      margin-top .3rem
    .contry-code
      width 0.6rem
      display flex
      color #ff5e2e
      justify-content center
      align-items center
    .phone-code-ipt
      flex 1
      border none
      outline none
      font-size 0.18rem
  .send-code-btn
    width 100%
    height .5rem
    color #ffffff
    font-size .18rem
    background-color tomato
    margin-top .3rem
    border none
    outline none
    border-radius .84rem
    &.disabled-btn
      opacity .2
  .code-block_wrap
    .code-block_ipt
      width 100%
      height .1rem
      margin-left -100rem

    .square-wrap
      height 0.6rem
      display flex
      justify-content space-between
      position relative
      margin-top .03rem
      .square-item
        width 0.5rem
        height 0.6rem
        border 1px solid #e5e5e5
        border-radius 0.08rem
        background-color #fff
        position relative
        display flex
        justify-content center
        align-items center
    .bottom-act-wrap
      display flex
      justify-content flex-end
      margin-top .2rem

      span.act-btn
        line-height .2rem
        font-size 0.14rem
        color #898b94


      .disactive
        color #c6c7cb

  .slide-fade-enter-active
    transition all 0.3s ease


  .slide-fade-leave-active
    transition all 0.3s cubic-bezier(1, 0.5, 0.8, 1)


  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */

    transform translateY(100px)
    opacity 0


  @keyframes fade
    from
      opacity 1

    50%
      opacity 0.4

    to
      opacity 1



  @-webkit-keyframes fade
    from
      opacity 1

    50%
      opacity 0.4

    to
      opacity 1



</style>
